import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
  position: relative;
`;

export const Title = styled.div`
  padding: 0px 0px 5px 0px;
  font-family: Roboto;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
`

export const SwipeableContainer = styled.div`
`

export const ViewAllButton = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 40px;
  top: -5px;
  right: 0px;
  border-radius: 5px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
  cursor: pointer;
  &:hover {
    background-color: ${C.LIGHTEST_GRAY};
  }
`
